import { render } from "./School_Preparation_Summary.vue?vue&type=template&id=2b88d7b8&scoped=true"
import script from "./School_Preparation_Summary.vue?vue&type=script&lang=js"
export * from "./School_Preparation_Summary.vue?vue&type=script&lang=js"

import "./School_Preparation_Summary.vue?vue&type=style&index=0&id=2b88d7b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b88d7b8"]])

export default __exports__